import { useEffect, useRef } from "react";
import { useShallow } from "zustand/shallow";

import { useBoundStore } from "../store";
import { profilesFetchers } from "@/services/api/fetchers/profiles";

export function useManageUserTimezone() {
  const userId = useBoundStore(useShallow((state) => state.user.id));
  const hasInitializedRef = useRef(false);

  useEffect(() => {
    if (!userId || hasInitializedRef.current) {
      return;
    }

    const loadUserTimezone = async () => {
      const profile = await profilesFetchers.fetchProfile(userId);
      const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      if (profile?.timezone !== currentTimezone) {
        // Update profile with current timezone
        await profilesFetchers.updateProfile(userId, { timezone: currentTimezone });
      }
    };

    hasInitializedRef.current = true;
    loadUserTimezone();
  }, [userId]);
}
